export const BOOLEAN_VARIABLE = 'BOOLEAN_VARIABLE'

export const defaultSettings = {
  type: BOOLEAN_VARIABLE,
  name: 'switch',
  value: true,
  description: 'Toggle Switch'
}
